<template>
  <el-dialog custom-class="min-dialog" title="新增优惠券" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true"
  >
    <el-form :model="form">
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="优惠券数量" :label-width="formLabelWidth" prop="count">
            <el-input-number v-model="form.count" @change="handleChange" :min="1"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="有效日期" :label-width="formLabelWidth">
            <el-date-picker style="width:260px;"
                            v-model="searchdatevalue"
                            type="daterange" :value-format="'yyyy-MM-dd'"
                            align="left" :unlink-panels="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="选择客户" :label-width="formLabelWidth" prop="couponnum">
            <AutoCustomer  @clear="clearCustomerName" :content="form.customername" :size="''" @handleSelect="selectExternalDept"></AutoCustomer>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData">确 定</el-button>
    </div>
  </el-dialog>
</template>


<script>
  import {saveData} from '@/api/set/salecoupon';
  import {couponLogSave} from '@/api/set/givecouponlog';
  export default {
    name: "SalecouponDialog",
    data() {
      return {
        data2: [],
        value4: [1],
        dialogFormVisible: false,
        formLabelWidth: '120px',
        form: {
          customername: '',
          count: 0,
          customerserial: '',
          customerserials: '',
          favourunitguid: ''
        },
        storeInfo: {
          coupon: '',
          province: '',
          city: '',
          county: '',
          independentserial: ''
        },//优惠券的地址和独立核算部门
        tableData: [],
        searchdatevalue:[],//有效日期
      }
    },
    methods: {
      customerChange(value, direction, movedKeys) {
        if (movedKeys.length == 0) {
          this.$message({
            type: 'error',
            message: '请选择客户!'
          });
          this.loading=false
        } else {
          this.form.customerserials = movedKeys.toString();
        }
      },
      bindGrid() {

      },
      show() {
        this.dialogFormVisible = true;
      },
      initForm(unitguid, storeInfo) {
        this.value4=[1]
        this.form.count = 1;
        this.form.customerserial = '';
        this.form.customername = '';
        this.form.favourunitguid = unitguid
        this.storeInfo.coupon = storeInfo.coupon
        this.storeInfo.province = storeInfo.province
        this.storeInfo.city = storeInfo.city
        this.storeInfo.county = storeInfo.county
        this.storeInfo.independentserial = storeInfo.independentserial
        this.loading=false
        this.bindGrid();
      },
      selExternal() {
        this.$refs.externalsel.show()
      },

      clearCustomerName(){
        this.form.customerserials = '';
        this.form.customername = '';
      },
      selectExternalDept(customerserial, deptname, row) {
        this.form.customerserials = customerserial;
        this.form.customername = deptname;
      },
      handleChange(value) {
        this.form.count = value
      },
      saveData() {
        if(this.form.customername==null||this.form.customername==''||this.form.customerserials==null||
          this.form.customerserials==''){
          this.$message.error('客户必须选择！');
          return;
        }
        if(!this.form.count||this.form.count<=0){
          this.$message.error('数量必选填写！');
          return;
        }
        this.form.begindate = this.searchdatevalue && this.searchdatevalue.length > 0 ? this.searchdatevalue[0] : ""
        this.form.enddate = this.searchdatevalue && this.searchdatevalue.length > 0 ? this.searchdatevalue[1] : ""
        if(!this.form.enddate){
          this.$message.error('有效结束日期必须填写！');
          return;
        }
        this.loading = true;
        saveData(this.form).then(response => {
          if (response.data.code === 0) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.couponLogSave();//优惠券赠送日志
            this.dialogFormVisible = false;
            this.$emit('bindGrid');
          } else {
            this.$message.error(response.data.msg);
            this.loading=false
          }
        });
      },
      //优惠券赠送日志
      couponLogSave() {
        couponLogSave({
          totalnumber: this.form.count,//赠送数量
          favourunitguid: this.form.favourunitguid,//优惠策略unitguid
          customerserial: this.form.customerserial,//客户编码
          customername: this.form.customername,//客户
        }).then(response => {

        })
      }
    },
    mounted() {
    },
    components: {},
  }
</script>



// WEBPACK FOOTER //
// src/components/set/salefavour/SalecouponDialog.vue